/**
 * Centralized API Configuration
 * Handles environment-based API URL configuration for development and production
 * 
 * Production Render Backend: https://mindwell-50i7.onrender.com
 * Development Localhost: http://localhost:8000
 */

// Production Render backend URL (default for production)
const PRODUCTION_API_URL = 'https://mindwell-50i7.onrender.com/api/v1';
const DEVELOPMENT_API_URL = 'http://localhost:8000/api/v1';

// Get API URL from environment variable or use defaults
const getApiUrl = () => {
  // Priority 1: Use environment variable if set (allows override in Netlify)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Priority 2: Use development URL for local development
  if (process.env.NODE_ENV === 'development') {
    return DEVELOPMENT_API_URL;
  }

  // Priority 3: Production fallback to Render URL
  // This ensures it works even if env var is not set in Netlify
  return PRODUCTION_API_URL;
};

// Get WebSocket URL
const getWebSocketUrl = () => {
  const apiUrl = getApiUrl();
  
  // Convert http/https to ws/wss and remove /api/v1 path
  // WebSocket connections are typically at root level
  let wsUrl = apiUrl.replace('/api/v1', '');
  
  if (wsUrl.startsWith('http://')) {
    return wsUrl.replace('http://', 'ws://');
  } else if (wsUrl.startsWith('https://')) {
    return wsUrl.replace('https://', 'wss://');
  }
  
  return wsUrl;
};

// Get base URL (without /api/v1)
const getBaseUrl = () => {
  const apiUrl = getApiUrl();
  return apiUrl.replace('/api/v1', '');
};

// API Configuration
export const API_CONFIG = {
  baseURL: getApiUrl(),
  baseUrl: getBaseUrl(),
  wsURL: getWebSocketUrl(),
  timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 60000, // 60 seconds for Render cold starts
  retryAttempts: parseInt(process.env.REACT_APP_API_RETRY_ATTEMPTS) || 3,
  retryDelay: parseInt(process.env.REACT_APP_API_RETRY_DELAY) || 2000, // 2 seconds between retries
};

// Export individual values for backward compatibility
export const API_BASE_URL = API_CONFIG.baseUrl;
export const API_URL = API_CONFIG.baseURL;
export const WS_URL = API_CONFIG.wsURL;

// Log configuration in development
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 API Configuration:', {
    baseURL: API_CONFIG.baseURL,
    wsURL: API_CONFIG.wsURL,
    timeout: API_CONFIG.timeout,
    retryAttempts: API_CONFIG.retryAttempts,
    environment: process.env.NODE_ENV,
    envVarSet: !!process.env.REACT_APP_API_URL,
  });
} else {
  // Log in production too (but only once, and only base URL)
  console.log('🌐 Production API:', API_CONFIG.baseURL);
}

export default API_CONFIG;

